import PropTypes from 'prop-types';

const BigIcon = ({ className, icon, svg }) => (
  <div className={`${className} bg-primary-color`} id="big-icon">
    {svg}
    {icon ? <i className="material-icons">{icon}</i> : null}
  </div>
);

BigIcon.propTypes = {
  className: PropTypes.string,
  icon: PropTypes.string,
  svg: PropTypes.object,
};

export default BigIcon;
